<h2>LCB Produtivo</h2>

<app-table
  [headers]="headers"
  [content]="filaList"
  [showFilter]="true"
  [hasEdit]="true"
  (editing)="edit($event)"
>
</app-table>
